import {ModelMetadata} from '../../../../../store/modelMetadata';
import {getModelLanguageText} from '../../../../../store/model';

export const getModelLanguageAndExecutionEnvironment = (metadata: ModelMetadata) => {
  return `${getModelLanguageText(metadata.type)}${
    metadata.model_execution_environment ? `/${metadata.model_execution_environment}` : ''
  }`;
};

/**
 * Adds a space after forward slashes in a string if not already present
 * @param text - The input string
 * @returns The string with spaces added after slashes
 * @example
 * addSpaceAfterSlash("Development/Submission Completed") // "Development/ Submission Completed"
 */
export const addSpaceAfterSlash = (text: string): string => {
  if (!text) return text;
  return text.replace(/\/(?! )/g, ' / ');
};
